(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["meego_remote_workitem"] = factory();
	else
		root["meego_remote_workitem"] = factory();
})(self, () => {
return 